import config from '@/config'
import Follow from '@/models/Follow'
import { useGlobalStore } from '@/store/app'
import BaseService from './BaseService'
import { ServiceWithStoreDependencies } from './decorators/serviceDecorators'
import { requests } from './HTTPService'

const http = requests(config?.COMMUNITIES_SERVER_URL)

@ServiceWithStoreDependencies('locationId')
class FollowServiceCls extends BaseService<Follow> {
  constructor() {
    super(null as any)
  }

  model() {
    return Follow
  }

  get endpoint(): string {
    const appStore = useGlobalStore()
    return `/${appStore.locationId}/follow`
  }

  async followUser(userId: string) {
    const response = await http.post(`${this.endpoint}/${userId}`)
    return response.data
  }

  async unfollowUser(userId: string) {
    const response = await http.delete(`${this.endpoint}/${userId}`)
    return response.data
  }

  async getFollowInfo(userId: string) {
    const response = await http.get(`${this.endpoint}/${userId}`)
    return response.data
  }

  async getFollowingUsers(
    contactId: string,
    limit: number,
    pageNumber?: number
  ) {
    const response = await http.get(`${this.endpoint}/${contactId}/following`, {
      params: {
        limit,
        pageNo: pageNumber ?? 1,
      },
    })
    return response.data
  }
  async getFollowersUsers(
    contactId: string,
    limit: number,
    pageNumber?: number
  ) {
    const response = await http.get(`${this.endpoint}/${contactId}/followers`, {
      params: {
        limit,
        pageNo: pageNumber ?? 1,
      },
    })
    return response.data
  }
}

export const FollowService = new FollowServiceCls()

export type IFollowService = FollowServiceCls
